import { ECategory } from '../../../repositories/price-estimator/entities/estimation/GetEstimationRealtorFormRequestSchema';

interface IGetCategoryParams {
  reason?: string;
  offerType?: string;
}

export const getCategory = (params: IGetCategoryParams): ECategory | null => {
  const { reason, offerType } = params;

  if (!reason || !offerType) {
    return null;
  }

  if (offerType === 'flat') {
    if (reason === 'sell') {
      return ECategory.FlatSale;
    } else if (reason === 'rentOut') {
      return ECategory.FlatRent;
    }
  }

  return null;
};
